module.exports = __webpack_public_path__ + "media/images/main_nav_user_agreement-2641fb467e4b5feb634a277e8f078d13.png";